import type { DayRange } from '@features/seasonal-theme/types';

export const addDays = (date: Date, days: number): Date =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate() + days);

/** `month` is 1-based. */
export const fixedRange = (
  year: number,
  [startMonth, startDay]: [number, number],
  [endMonth, endDay]: [number, number]
): DayRange => ({
  start: new Date(year, startMonth - 1, startDay),
  end: new Date(year, endMonth - 1, endDay),
});

export const isWithin = (date: Date, { start, end }: DayRange): boolean => {
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();

  return day >= start.getTime() && day <= end.getTime();
};

/** Easter Sunday (Gregorian calendar, anonymous algorithm). */
export const easterSunday = (year: number): Date => {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;

  return new Date(year, month - 1, day);
};

/** French Mother's Day: last Sunday of May, moved to the first Sunday of June when it falls on Pentecost. */
export const frenchMothersDay = (year: number): Date => {
  const lastOfMay = new Date(year, 4, 31);
  const lastSundayOfMay = addDays(lastOfMay, -lastOfMay.getDay());
  const pentecost = addDays(easterSunday(year), 49);

  return lastSundayOfMay.getTime() === pentecost.getTime() ? addDays(lastSundayOfMay, 7) : lastSundayOfMay;
};

/** Black Friday: the day after the fourth Thursday of November. */
export const blackFriday = (year: number): Date => {
  const firstOfNovember = new Date(year, 10, 1);
  const firstThursday = addDays(firstOfNovember, (4 - firstOfNovember.getDay() + 7) % 7);

  return addDays(firstThursday, 22);
};
